// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoBlock_logo__Wayor","image":"LogoBlock_image__0Dzuc","text":"LogoBlock_text__ug2xo"};